import { ETableColumnType, ITableColumn } from './../../store/models/table.model';
import { ELastContacts, ILastContactsItem } from './../../store/models/user-group.model';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DIALOG_COMPONENT, DialogComponent } from '../../shared/ui/dialog/dialog.component';

@Component({
  selector: 'app-last-contacts',
  templateUrl: './last-contacts.component.html',
  styleUrls: ['./last-contacts.component.scss'],
})
export class LastContactsComponent implements OnInit {
  @Input() type: ELastContacts;

  tableColumns: ITableColumn<ILastContactsItem>[] = [
    {
      id: 'contact_firstname',
      title: 'First Name',
    },
    {
      id: 'contact_lastname',
      title: 'Last Name',
    },
    {
      id: 'contact_email',
      title: 'Email',
      type: ETableColumnType.ANCHOR,
      anchorHandler: (column: ITableColumn<ILastContactsItem>, row: ILastContactsItem) => {
        this.dialogComponent.closeDialog();
        this.router.navigate(['/', 'user_contacts', row.contact_id, 'edit'], {
          queryParams: {
            no_email: 'true'
          }
        })
      }
    },
    {
      id: 'contact_company',
      title: 'Company',
    },
    {
      id: 'contact_created',
      title: 'Date',
      isDateColumn: true,
      dateFormat: 'MM/DD/YYYY'
    },
    {
      id: 'account_email',
      title: 'Representative',
      renderer: (row: ILastContactsItem) => `${row.account_firstname} ${row.account_lastname}`,
    },
  ];

  dataSource: ApiDataSource<ILastContactsItem>;

  tableDataSourceParams;

  constructor(
    private http: HttpClient,
    private readonly router: Router,
    @Inject(DIALOG_COMPONENT) private readonly dialogComponent: DialogComponent,
  ) {}

  ngOnInit() {
    this.tableDataSourceParams = {
      page: 1,
      pageSize: 10,
      filters: {
        count_only: 'false',
        part: this.type,
      },
    };

    this.dataSource = new ApiDataSource<ILastContactsItem>(
      this.http,
      environment.apiUrl + '/v1/contacts/last'
    );
  }
}
